<dspx-card-set-base-form [fieldTypeReplacements]="fieldTypeReplacements"
                         [formServiceEndpoint]="formServiceEndpoint"
                         [templateId]="templateId"
                         [versionNo]="versionNo"
                         formName="Approver COI Form"
                         [entityId]="id"
                         (onFormLoad)="formLoaded($event)"
                         (onModelChange)="modelChanged($event)"
                         (onDialogSubmit)="dialogSubmitted($event)"
                         (onActionButtonClick)="actionButtonClicked($event)"
                         (onSave)="save($event)"
                         (onCancel)="cancel($event)">
</dspx-card-set-base-form>
